import React from "react";
import Image from "next/legacy/image";
import classNames from "classnames";
import Link from "next/link";

export default function LogosGrid({
  logos = logoArray,
  cols = 4,
  snapOnMobile = true,
}) {
  const gridCols = classNames(
    {
      5: "md:grid-cols-5",
      4: "md:grid-cols-4",
      3: "md:grid-cols-3",
      2: "md:grid-cols-2",
    }[cols],
    snapOnMobile ? "block md:grid" : "grid grid-cols-2"
  );

  return (
    <div className={gridCols}>
      {logos.map((logo, i) => (
        <div
          key={i}
          className=" flex h-[116px] items-center justify-center border border-neutral-100 align-middle"
        >
          <Link href={logo["_amb_sponsor_link"]} passHref target="_blank">
            <div className="max-w-1/2">
              <Image
                width={300}
                height={100}
                src={logo["Image Featured"]}
                alt={logo["Title"]}
              ></Image>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}

const logoArray = [
  {
    "Image Featured":
      "https://www.ambulante.org/wp-content/uploads/2019/04/logos_web_CDMX__EnFilme.png",
    alt: "EnFilme",
  },
  {
    "Image Featured":
      "https://www.ambulante.org/wp-content/uploads/2018/01/qro_Cine-Morelia_2020.png",
    alt: "Cine Morelia",
  },
  {
    "Image Featured":
      "https://www.ambulante.org/wp-content/uploads/2022/08/Cinepolis_SaladeArte.png",
    alt: "Cinepolis Sala de Arte",
  },
];
